import React, {PureComponent} from 'react'
import { Column, Table, AutoSizer } from 'react-virtualized'
import 'react-virtualized/styles.css'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { BLUE, LIGHT_BLUE } from '../colors'

// this makes the table scale to its container
const StyledTable = styled.div`
    width:100%;
    flex: 1 1 auto;
    padding:20px 0;
    .ReactVirtualized__Table{
        
    }
    .ReactVirtualized__Table__headerRow{
        color:${BLUE};
    }

    .ReactVirtualized__Table__row{
        -webkit-transition: all 0.3s ease-out; 
        transition: all 0.3s ease-out;
        align-items:center;
        border-left:3px solid transparent;
        &:hover{
            box-shadow: 0 2px 14px 0 rgba(0,0,0,0.09);
            border-left:3px solid ${BLUE};
        }
    }
    .ReactVirtualized__Table__rowColumn{
        align-items:center;
        color:${LIGHT_BLUE};
        font-size:15px;
        a{
            color:${BLUE};
            font-size:22px;
            text-decoration:none;
            display:flex;
            align-items:center;
            font-weight:300;
            svg{
                margin-right:10px;
            }
        }
    }
`

export const DataColumn = Column

export class DataTable extends PureComponent {
    constructor (props, context) {
        super(props, context)
    
        this.state = {
            data: props.data // Naturally sorted list
        }
    }
    componentWillReceiveProps(props){
        this.setState({
            data:props.data
        })
    }

    _rowGetter = ({index})=>{
        return this.state.data[index]
    }
  
    render () {
        const { data = []} = this.state
        const {sortBy, sortDirection, onSort} = this.props
    
        return (
        
            <StyledTable className="data-table">
                <AutoSizer>
                    {({ height, width }) => {
                        return <Table
                            {...this.props}
                            headerHeight={50}
                            width={width}
                            height={height}
                            sort={onSort}
                            sortBy={sortBy}
                            sortDirection={sortDirection}
                            rowCount={data.length}
                            rowGetter={this._rowGetter}
                            rowHeight={72}
                        >
                            {this.props.children}
                        </Table>
                    }}
                </AutoSizer>
            </StyledTable>
         
        )
    }
}


DataTable.propTypes = {
    className: PropTypes.string,
    data: PropTypes.any,
    children: PropTypes.any
}



// WEBPACK FOOTER //
// ./src/components/ui/dataTable.js